import type { FC } from 'react';
import { Form, InputNumber } from 'antd';
import type { FormInstance } from 'antd';

export interface KpisFormValues {
  impressions?: number;
  clicks?: number;
  engagementRate?: number;
  leads?: number;
  conversions?: number;
}

interface CampaignKpisTabProps {
  form: FormInstance<KpisFormValues>;
}

const CampaignKpisTab: FC<CampaignKpisTabProps> = ({ form }) => (
  <Form form={form} layout="vertical" className="mt-2">
    <div className="grid grid-cols-2 gap-4">
      <Form.Item name="impressions" label="Impressions">
        <InputNumber className="w-full" min={0} placeholder="0" />
      </Form.Item>
      <Form.Item name="clicks" label="Clics">
        <InputNumber className="w-full" min={0} placeholder="0" />
      </Form.Item>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <Form.Item name="engagementRate" label="Taux engagement (%)">
        <InputNumber className="w-full" min={0} max={100} step={0.1} placeholder="0.0" />
      </Form.Item>
      <Form.Item name="leads" label="Leads générés">
        <InputNumber className="w-full" min={0} placeholder="0" />
      </Form.Item>
    </div>
    <Form.Item name="conversions" label="Conversions">
      <InputNumber className="w-full" min={0} placeholder="0" />
    </Form.Item>
  </Form>
);

export default CampaignKpisTab;
